import login from '../assets/install-01-login.jpg'
import calendar from '../assets/install-02-calendar.jpg'
import menu from '../assets/install-03-menu.jpg'
import installDialog from '../assets/install-04-install-dialog.jpg'
import addToHome from '../assets/install-05-add-to-home.jpg'
import homeScreen from '../assets/install-06-home-screen.jpg'
import inApp from '../assets/install-07-in-app.jpg'
import iosLogin from '../assets/install-ios-01-login.jpg'
import iosSafari from '../assets/install-ios-02-safari.jpg'
import iosShareMenu from '../assets/install-ios-03-share-menu.jpg'
import iosAddDialog from '../assets/install-ios-04-add-dialog.jpg'
import iosHomeScreen from '../assets/install-ios-05-home-screen.jpg'
import iosInApp from '../assets/install-ios-06-in-app.jpg'
import iosPermission from '../assets/install-ios-07-permission.jpg'
import { box, type GuideStepContent } from './guideStep'

export const INSTALL_APP_INTRO =
  'Mit der App öffnen Sie den Werkhof direkt vom Startbildschirm — ohne Browserleiste und mit Benachrichtigungen auf dem Handy.'

export const INSTALL_APP_STEPS: Record<'android' | 'ios', GuideStepContent[]> = {
  android: [
    {
      title: 'Werkhof im Browser öffnen',
      text: 'Öffnen Sie Chrome, geben Sie die Adresse des Werkhofs ein und melden Sie sich mit E-Mail und Passwort an.',
      image: login,
      imageAlt: 'Anmeldeseite des Werkhofs in Chrome',
      focus: [box(105, 130, 702, 235), box(105, 1335, 818, 1472)],
    },
    {
      title: 'Menü öffnen',
      text: 'Nach der Anmeldung sehen Sie Ihren Kalender. Tippen Sie oben rechts auf das Menü ☰.',
      image: calendar,
      imageAlt: 'Kalender mit Menü-Symbol oben rechts',
      focus: [box(795, 280, 890, 355)],
    },
    {
      title: '„App installieren“ wählen',
      text: 'Ganz unten im Menü steht „App installieren“. Tippen Sie darauf.',
      image: menu,
      imageAlt: 'Menü mit dem Eintrag „App installieren“',
      focus: [box(255, 1735, 905, 1815)],
    },
    {
      title: 'Installation bestätigen',
      text: 'Es öffnet sich ein Fenster „WGH Reparaturservice“. Tippen Sie auf „Installieren“ (je nach Handysprache „Install“).',
      image: installDialog,
      imageAlt: 'Chrome-Fenster zum Installieren der App',
      focus: [box(700, 1188, 850, 1255)],
    },
    {
      title: 'Zum Startbildschirm hinzufügen',
      text: 'Tippen Sie auf „Zum Startbildschirm hinzufügen“ (je nach Handysprache „Add to home screen“).',
      image: addToHome,
      imageAlt: 'Fenster „Zum Startbildschirm hinzufügen“',
      focus: [box(508, 1810, 890, 1928)],
    },
    {
      title: 'App auf dem Startbildschirm',
      text: 'Das Symbol „Werkhof“ liegt jetzt auf Ihrem Startbildschirm. Öffnen Sie die App ab jetzt darüber.',
      image: homeScreen,
      imageAlt: 'Startbildschirm mit dem Werkhof-Symbol',
      focus: [box(55, 140, 225, 365)],
    },
    {
      title: 'Benachrichtigungen aktivieren',
      text: 'Die App öffnet sich ohne Browserleiste. Tippen Sie im Hinweis oben auf „Aktivieren“ und erlauben Sie die Benachrichtigungen. Dann erhalten Sie neue Termine und Aufgaben direkt auf dem Handy.',
      image: inApp,
      imageAlt: 'Werkhof-App ohne Browserleiste',
      focus: [box(528, 380, 768, 482)],
    },
  ],
  ios: [
    {
      title: 'Werkhof in Safari öffnen',
      text: 'Auf dem iPhone und iPad funktioniert das Hinzufügen nur über Safari. Öffnen Sie den Werkhof dort und melden Sie sich mit E-Mail und Passwort an.',
      image: iosLogin,
      imageAlt: 'Anmeldeseite des Werkhofs in Safari',
      focus: [box(18, 108, 906, 190), box(135, 1235, 788, 1358)],
    },
    {
      title: 'Teilen-Symbol tippen',
      text: 'Nach der Anmeldung sehen Sie Ihren Kalender. Tippen Sie unten in der Leiste auf das Teilen-Symbol (Quadrat mit Pfeil nach oben).',
      image: iosSafari,
      imageAlt: 'Kalender in Safari mit Teilen-Symbol unten',
      focus: [box(405, 1832, 510, 1925)],
    },
    {
      title: '„Zum Home-Bildschirm“ wählen',
      text: 'Im Menü finden Sie „Zum Home-Bildschirm“. Wischen Sie in der Liste nach oben, falls der Eintrag nicht sofort sichtbar ist, und tippen Sie darauf.',
      image: iosShareMenu,
      imageAlt: 'Teilen-Menü mit dem Eintrag „Zum Home-Bildschirm“',
      focus: [box(40, 1125, 884, 1237)],
    },
    {
      title: 'Mit „Hinzufügen“ bestätigen',
      text: 'Der Name „Werkhof“ ist schon eingetragen. Tippen Sie oben rechts auf „Hinzufügen“.',
      image: iosAddDialog,
      imageAlt: 'Dialog „Zum Home-Bildschirm“ mit dem Namen Werkhof',
      focus: [box(672, 148, 892, 222)],
    },
    {
      title: 'App auf dem Home-Bildschirm',
      text: 'Das Symbol „Werkhof“ liegt jetzt auf Ihrem Home-Bildschirm. Öffnen Sie die App ab jetzt darüber.',
      image: iosHomeScreen,
      imageAlt: 'Home-Bildschirm mit dem Werkhof-Symbol',
      focus: [box(66, 146, 224, 346)],
    },
    {
      title: 'Einmal neu anmelden',
      text: 'Die App hat eine eigene Anmeldung: Melden Sie sich beim ersten Öffnen einmal neu an. Danach öffnet sich der Kalender ohne Browserleiste. Tippen Sie im Hinweis oben auf „Aktivieren“.',
      image: iosInApp,
      imageAlt: 'Werkhof-App mit Hinweis „Benachrichtigungen einschalten“',
      focus: [box(556, 322, 784, 417)],
    },
    {
      title: 'Benachrichtigungen erlauben',
      text: 'iOS fragt nach: „Werkhof“ möchte dir Mitteilungen senden. Tippen Sie auf „Erlauben“. Das geht auf dem iPhone nur in der installierten App (ab iOS 16.4). Dann erhalten Sie neue Termine und Aufgaben direkt auf dem Handy.',
      image: iosPermission,
      imageAlt: 'iOS-Abfrage „Werkhof möchte dir Mitteilungen senden“',
      focus: [box(172, 1178, 752, 1272)],
    },
  ],
}
